<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/white_card/"
                       data-key="white_cards"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       class="white-card-list"
                       v-bind="$attrs">
    <template #item.id="{value, item}">
      <span :class="{'deactivated': !item.active}">{{ `A${value.toString().padStart(5, '0')}` }}</span>
    </template>
    <template #item.account="{item}">
      <span v-if="item.active_record">{{ $t('name', {given_name: item.active_record.account.given_name, surname: item.active_record.account.surname}) }}</span>
      <v-btn icon
             @click="editItem(item)"
             v-if="item.active_record">
        <v-icon>fas fa-search</v-icon>
      </v-btn>
    </template>
    <template #item.active="{value, item}">
      <v-icon v-if="value"
              :key="item.id">fas fa-check
      </v-icon>
    </template>
    <!--    <template #item.user="{item}">-->
    <!--      {{ getUserLabel(item) }}-->
    <!--    </template>-->
    <!--    <template #item.booking="{item}">-->
    <!--      {{ getFacilityLabel(item) }}-->
    <!--    </template>-->
    <template v-slot:item.actions="{item}">
      <v-menu offset-y
              rounded
              left
              v-if="!hideActions">
        <template v-slot:activator="{on}">
          <v-btn icon
                 v-on="on">
            <v-icon>fas fa-cog</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-2">
          <v-list-item @click="exportWhiteCard(item)"
                       :disabled="!item.active">
            <v-icon>fas fa-qrcode</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('admin_acc_white_card.export') }}</label>
          </v-list-item>
          <v-list-item @click="deactivateWhiteCard(item)"
                       v-if="item.active">
            <v-icon>fas fa-times-circle</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('admin_acc_white_card.deactivate') }}</label>
          </v-list-item>
          <v-list-item @click="reactivateWhiteCard(item)"
                       v-if="!item.active">
            <v-icon>fas fa-check-circle</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('admin_acc_white_card.reactivate') }}</label>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import WhiteCardActiveRecordModal from "@/components/acc_booking/white_card/WhiteCardActiveRecordModal";

export default {
  name: 'WhiteCardList',
  components: {WhiteCardActiveRecordModal, RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    hideActions: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_acc_location.name_en'), value: 'name_en', contains: true},
        // {text: root.$t('admin_acc_location.name_zh'), value: 'name_zh', contains: true},
        {text: root.$t('admin_acc_white_card.id'), value: 'id', contains: true},
        {
          text: root.$t('admin_acc_white_card.user'), value: 'active_record',
          options: [
            {text: root.$t('yes'), value: true},
            {text: root.$t('no'), value: false},
          ], single: true,
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_white_card.id'), value: 'id'},
      {text: root.$t('admin_acc_white_card.active'), value: 'active'},
      {text: root.$t('admin_acc_white_card.user'), value: 'account', sortable: false},
      {text: '', value: 'actions'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    //

    const editItem = function (item) {
      if (item.active_record) {
        emit('record', item.active_record.id);
      }
    };
    const exportWhiteCard = function (item) {
      root.$downloadFile('aafb/admin/white_card/export/', {
        white_card_id: item.id,
      }, 'white_cards.zip', 'application/zip')
    }
    const deactivateWhiteCard = function (item) {
      if (confirm(root.$t('admin_acc_white_card.deactivate_confirm_msg'))) {
        root.$callAPI('aafb/admin/white_card/deactivate/', {white_card_id: item.id}, (response) => {
          refresh();
        })
      }
    }
    const reactivateWhiteCard = function (item) {
      if (confirm(root.$t('admin_acc_white_card.reactivate_confirm_msg'))) {
        root.$callAPI('aafb/admin/white_card/reactivate/', {white_card_id: item.id}, (response) => {
          refresh();
        })
      }
    }


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      exportWhiteCard,
      deactivateWhiteCard,
      reactivateWhiteCard,
    }
  }
}
</script>

<style lang="less">
.white-card-list {
  .deactivated {
    text-decoration: line-through;
    opacity: 0.5;
  }
}
</style>
